
/**
 * params {num} number
 */
export const monthTurn=function(num){
  const month={
    1:'一个月',
    2:'二个月',
    3:'三个月',
    4:'四个月',
    5:'五个月',
    6:'六个月',
    7:'七个月',
    8:'八个月',
    9:'九个月',
    10:'十个月',
    11:'十一个月',
    12:'一年'
  }
  return month[num]
}

// 截取字符串

export const charString=function(str){
  let sring='';
  for(let i=0;i<str.length;i++){
    if(str[i]=='2'&&str[i-1]=='S'&&str[i-2]=='F'&&str[i-3]=='/'){
        return sring;
    }else{
      sring+=str[i]
    }
  }
  // console.log(sring)
}

// 时间戳转换正常事件

 
export function timestampToTime(timestamp) {
  // 时间戳为10位需*1000，时间戳为13位不需乘1000
  let str=timestamp+''
  if(str.length==10){
    var date = new Date(timestamp * 1000);
  }else{
    var date = new Date(timestamp);
  }
  var Y = date.getFullYear() + "-";
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate()) + " ";
  var h = date.getHours() + ":";
  var m = date.getMinutes() + ":";
  var s = date.getSeconds();
  return Y + M + D + h + m + s;
}
export function getDay(timestamp) {
  // 时间戳为10位需*1000，时间戳为13位不需乘1000
  var date = new Date(timestamp * 1000);
  var Y = date.getFullYear() + "-";
  var M =
    (date.getMonth() + 1 < 10
      ? "0" + (date.getMonth() + 1)
      : date.getMonth() + 1) + "-";
  var D = (date.getDate() < 10 ? "0" + date.getDate() : date.getDate());
  return Y + M + D ;
}

// 有重复值范围所有值的位置
export function getDuplicateIndexes(arr,val) {
  const indexes = [];
  for (let i = 0; i < arr.length; i++) {
    if (arr[i]==val) {
      indexes.push(i);
    }
  }
  return indexes;
}
// 判断是否存在重复的值
export function hasDuplicates(array) {
  const seen = new Set();
  for (let i = 0; i < array.length; i++) {
    if (seen.has(array[i])) {
      return true;
    }
    seen.add(array[i]);
  }
  return false;
}

// 获取零点时间戳
export function getOneTimestamp() {
  var startOfToday = new Date();
  startOfToday.setHours(0, 0, 0, 0);
  var startTimestamp = startOfToday.getTime();
  return startTimestamp
}

// 标准时间转YYYY-MM-DD
export function formatDate(dateStr) {
  const date = new Date(dateStr);
  const year = date.getFullYear();
  const month = (date.getMonth() + 1).toString().padStart(2, '0');
  const day = date.getDate().toString().padStart(2, '0');
  return `${year}-${month}-${day}`;
}
// 获取当前日期的前七天期

export function getSevenDaysAgo(format = 'YYYY-MM-DD') {
  const today = new Date();
  const sevenDaysAgo = new Date(today);
  sevenDaysAgo.setDate(today.getDate() - 7);

  // 日期格式化
  const pad = n => n.toString().padStart(2, '0');
  return format
    .replace('YYYY', sevenDaysAgo.getFullYear())
    .replace('MM', pad(sevenDaysAgo.getMonth() + 1))
    .replace('DD', pad(sevenDaysAgo.getDate()));
}

// 获取今日的yyyy-mm-dd
export function getTodayDate() {
  const date = new Date();
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0'); // 月份补零
  const day = String(date.getDate()).padStart(2, '0');        // 日期补零
  return `${year}-${month}-${day}`;
}

export function rewirteLog() {
  if (!['development', 'mock'].includes(process.env.NODE_ENV)) {
    ['log', 'warn', 'error', 'info'].forEach((item) => {
      // eslint-disable-next-line func-names
      console[item] = (function (func) {
        const res = localStorage.getItem('debug');
        if (res === 'GMV_desk') {
          return func;
        }
        // eslint-disable-next-line func-names
        return function () {};
      })(console[item]);
    });
  }
}

// yyyy--mm--dd时间转为时间戳
export function convertToTimestamp(dateString) {
    const date = new Date(dateString);  // 解析日期字符串，得到的是本地时间（中国的本地时间）
    const utcDate = new Date(date.getTime() - (8 * 60 * 60 * 1000));  // 调整为 UTC 时间
    return utcDate.getTime(); 
}
